var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"admin"},[_c('Menu',{attrs:{"id":"menu"}}),_c('router-view',{staticClass:"content"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }